import { render, staticRenderFns } from "./NewsBannersCreate.vue?vue&type=template&id=8f1a2710&scoped=true"
import script from "./NewsBannersCreate.vue?vue&type=script&lang=js"
export * from "./NewsBannersCreate.vue?vue&type=script&lang=js"
import style0 from "./NewsBannersCreate.vue?vue&type=style&index=0&id=8f1a2710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1a2710",
  null
  
)

export default component.exports